export const WIDGET_UPLOAD_SUCCESS = "WIDGET_UPLOAD_SUCCESS"
export const CLIENT_ID_UPLOAD_SUCCESS = "CLIENT_ID_UPLOAD_SUCCESS"
export const ACTIVITY_UPLOAD_SUCCESS = "ACTIVITY_UPLOAD_SUCCESS"
export const CLIENT_PAYMENT_ACCOUNT_UPLOAD_SUCCESS = "CLIENT_PAYMENT_ACCOUNT_UPLOAD_SUCCESS"
